import classNames from 'classnames';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { navCategoryImageLookupFn } from '../../hooks/actions/useNavCategories';
import { NavCategorySet } from '../../models/NavCategorySet.model';
import { ImageLoader } from '../../product_detail/components/ImageLoader';
import { assetPathFnState, pageContextState } from '../../recoil/atoms';
import { isMobileState } from '../../recoil/selectors';
import { Link } from '../../root/components/Link';
import styles from './CollectionCategory.module.scss';

interface Props {
  navCategorySet: NavCategorySet;
  isActive: boolean;
}

export const CollectionCategory: React.FC<Props> = ({ navCategorySet, isActive }) => {
  const assetPathFn = useRecoilValue(assetPathFnState);
  const pageContext = useRecoilValue(pageContextState);
  const imageLookup = navCategoryImageLookupFn(assetPathFn);
  const isMobile = useRecoilValue(isMobileState);
  const image = imageLookup(navCategorySet.navCategory, isMobile ? 'small' : 'large');

  return image ? (
    <Link href={navCategorySet.link} buttonType="ghost" dataTrackLabel={navCategorySet.title} dataTrackLocation={pageContext}>
      <div className={classNames(styles.imageLink, { [styles.isActive]: isActive })}>
        <ImageLoader src={image} alt={navCategorySet.title} />
        <div className={styles.collectionTitle}>{navCategorySet.title}</div>
      </div>
    </Link>
  ) : (
    <React.Fragment />
  );
};

export default CollectionCategory;
